import Vue from 'vue';

export const namespaced = true;
export const state = {
  notifications: [],
};

let nextId = 1;
export const mutations = {
  PUSH(state, notification) {
    // NOTE: Notification family should be unique else it will replace previous member
    const duplicateFamilyIdx = notification.family ? state.notifications.findIndex(n => n.family === notification.family) : -1;
    if (duplicateFamilyIdx !== -1 && notification.overrideDuplicate === false) return; // If override duplicate is false then we ignore new notification with same family name
    const newNotification = {
      ...notification,
      id: nextId++,
    };
    if (duplicateFamilyIdx === -1) state.notifications.push(newNotification);
    else Vue.set(state.notifications, duplicateFamilyIdx, newNotification);
  },
  DELETE(state, notificationToRemove) {
    state.notifications = state.notifications.filter(notification => notification.id !== notificationToRemove.id);
  },
};

export const actions = {
  add({ commit }, notification) {
    commit('PUSH', notification);
  },
  remove({ commit }, notificationToRemove) {
    commit('DELETE', notificationToRemove);
  },
  notifySuccess({ commit }, { message, options }) {
    return new Promise(resolve => {
      commit('PUSH', {
        type: 'success',
        text: { class: 'text-secondary font-weight-bold' },
        icon: {
          icon: ['fal', 'check-circle'],
          size: 'lg',
          class: 'mr-2',
        },
        message,
        ...options,
      });
      resolve();
    });
  },
  notifyFailure({ commit }, { message, options }) {
    return new Promise(resolve => {
      commit('PUSH', {
        type: 'danger',
        text: { class: 'font-weight-bold' },
        icon: {
          icon: ['far', 'times-circle'],
          size: 'lg',
          class: 'mr-2',
        },
        message,
        ...options,
      });
      resolve();
    });
  },
};

export const getters = {
  hasNotification: state => state.notifications.length > 0,
};
